<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <div class="container-fluid">
                <form id="FormCuentaPagar" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <label for="">Proveedor</label>
                            <treeselect
							    :options="ListaProveedores"
							    :placeholder="'Selecciona el Proveedor'"
                                :disabled="objCuentaPorPagar.IdCuentaPagar!=0"
							    v-model="objCuentaPorPagar.IdProveedor"
                                @input="RellenarCampos()"
							    >
							</treeselect>
                            <CValidation v-if="this.errorvalidacion.IdProveedor" :Mensaje="'*'+errorvalidacion.IdProveedor[0]"/>
                        </div>
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <label for="">Carga XML</label>
                            <input type="file" class="form-control">
                        </div>
                    </div>
                    
                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <label class="form-label" for="NumDeCompra">N° de Nota / N° de Factura</label>
                            <input :disabled="objCuentaPorPagar.IdCuentaPagar!=0" type="text" class="form-control" id="NumDeCompra" v-model="objCuentaPorPagar.NumDeCompra" placeholder="N° de Nota / N° de Factura">
                            <CValidation v-if="this.errorvalidacion.NumDeCompra" :Mensaje="'*'+errorvalidacion.NumDeCompra[0]"/>
                        </div>
                    </div>
                    
                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <label class="form-label" for="Concepto">Conceptos</label>
                            <textarea :disabled="objCuentaPorPagar.IdCuentaPagar!=0" id="Concepto" cols="30" rows="6" v-model="objCuentaPorPagar.Concepto" class="form-control"></textarea>
                            <CValidation v-if="this.errorvalidacion.Concepto" :Mensaje="'*'+errorvalidacion.Concepto[0]"/>
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <label class="form-label" for="MetodoPago">Método de Pago</label>
                            <select :disabled="objCuentaPorPagar.IdCuentaPagar!=0" id="MetodoPago" class="form-control-search form-select" v-model="objCuentaPorPagar.MetodoDePago">
                                <option value="">-- Seleccione un Método de Pago --</option>
                                <option v-for="(item,index) in ListaMetodoPago" :value="item.Nombre" :key="index">{{ item.Clave+' - '+item.Nombre }}</option>
                            </select>
                            <CValidation v-if="this.errorvalidacion.MetodoDePago" :Mensaje="'*'+errorvalidacion.MetodoDePago[0]"/>
                        </div>
                        <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                            <label class="form-label" for="Importe">Importe</label>
                            <input :disabled="objCuentaPorPagar.IdCuentaPagar!=0" @input="$number_decimal($event,objCuentaPorPagar,'Importe');" type="text" class="form-control" id="Importe" v-model="objCuentaPorPagar.Importe" placeholder="Importe">
                            <CValidation v-if="this.errorvalidacion.Importe" :Mensaje="'*'+errorvalidacion.Importe[0]"/>
                        </div>
                        <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                            <label class="form-label" for="FechaCompra">Fecha Compra</label>
                            <div class="calendar">
                                <Datepicker :disabled="objCuentaPorPagar.IdCuentaPagar!=0" v-model="objCuentaPorPagar.FechaCompra" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" :disabled-dates="{from:new Date(Date.now())}" placeholder="0000-00-00"></Datepicker>
                            </div>
                            <CValidation v-if="this.errorvalidacion.FechaCompra" :Mensaje="'*'+errorvalidacion.FechaCompra[0]"/>
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <label class="form-label" for="FormaPago">Forma de Pago</label>
                            <select :disabled="objCuentaPorPagar.IdCuentaPagar!=0" id="FormaPago" class="form-control-search form-select" v-model="objCuentaPorPagar.FormaDePago">
                                <option value="">-- Seleccione una Forma de Pago --</option>
                                <option v-for="(item,index) in ListaFormaPago" :value="item.Nombre" :key="index">{{ item.Clave+' - '+item.Nombre }}</option>
                            </select>
                            <CValidation v-if="this.errorvalidacion.FormaDePago" :Mensaje="'*'+errorvalidacion.FormaDePago[0]"/>
                        </div>
                        <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                            <label class="form-label" for="DiasCredito">Dias de Crédito</label>
                            <input @input="$onlyNums($event,objCuentaPorPagar,'DiasCredito');" @change="CalcularFechaPago()" type="text" class="form-control" id="DiasCredito" v-model="objCuentaPorPagar.DiasCredito" placeholder="Días de Crédito">
                            <CValidation v-if="this.errorvalidacion.DiasCredito" :Mensaje="'*'+errorvalidacion.DiasCredito[0]"/>
                        </div>
                        <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                            <label for="">Fecha Pago</label>
                            <div class="calendar">
                                <Datepicker @input="CalcularDiaCredito" v-model="objCuentaPorPagar.FechaPago" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" :disabled-dates="Setpicker.DisabledDates" placeholder="0000-00-00"></Datepicker>
                            </div>
                            <CValidation v-if="this.errorvalidacion.FechaPago" :Mensaje="'*'+errorvalidacion.FechaPago[0]"/>
                        </div>
                    </div>
                </form>
            </div>
        </template>
    </CLoader>
</template>

<script>
import moment from 'moment';
import Calendar from '@/helpers/StaticComboBox.js';
export default {
    name: 'FormCuentaPorPagar',
    props: ['poBtnSave'],
    data() {
        return {
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCuentaPorPagar:{
                IdCuentaPagar:0,
                NumDeCompra:'',
                Concepto:'',
                Importe:0,
                FechaCompra:'',
                FechaPago:'',
                DiasCredito:0,
                Estatus:'',
                IdProveedor:null,
                IdUsuario:0,
                xml:'',
                uuid:'',
                FechaPagado:'',
                MetodoDePago:'',
                FormaDePago:''
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
            Setpicker:Calendar.calendarSettings,
            ListaProveedoresBusqueda:[],
            ListaProveedores:[],
            ListaMetodoPago:[],
            ListaFormaPago:[]
        }
    },
    methods: {
        async Guardar(){
            this.poBtnSave.DisableBtn=true;
            let BndError=false;
            let Mensaje='';
            if (this.objCuentaPorPagar.IdProveedor==null) {
                BndError=true;
                Mensaje="Debe Seleccionar un Proveedor";
            }
            if (BndError) {
                this.poBtnSave.DisableBtn=false;
                this.$toast.warning(Mensaje);
                return false;
            }
            let FechaCompra='';
            if (this.objCuentaPorPagar.FechaCompra!='') {
                let day=this.objCuentaPorPagar.FechaCompra.getDate();
                let month=this.objCuentaPorPagar.FechaCompra.getMonth()+1;
                let year=this.objCuentaPorPagar.FechaCompra.getFullYear();
                FechaCompra=year+'-'+month+'-'+day;   
            }
            let FechaPago='';
            if (this.objCuentaPorPagar.FechaPago!='') {
                let day=this.objCuentaPorPagar.FechaPago.getDate();
                let month=this.objCuentaPorPagar.FechaPago.getMonth()+1;
                let year=this.objCuentaPorPagar.FechaPago.getFullYear();
                FechaPago=year+'-'+month+'-'+day;   
            }

            let formData=new FormData();
            formData.set('NumDeCompra',this.objCuentaPorPagar.NumDeCompra);
            formData.set('Concepto',this.objCuentaPorPagar.Concepto);
            formData.set('Importe',this.objCuentaPorPagar.Importe);
            formData.set('FechaCompra',FechaCompra);
            formData.set('FechaPago',FechaPago);
            formData.set('DiasCredito',this.objCuentaPorPagar.DiasCredito);
            formData.set('Estatus','Pendiente');
            formData.set('IdProveedor',this.objCuentaPorPagar.IdProveedor);
            formData.set('IdUsuario',this.objCuentaPorPagar.IdUsuario);
            formData.set('xml',this.objCuentaPorPagar.xml);
            formData.set('uuid',this.objCuentaPorPagar.uuid);
            formData.set('MetodoDePago',this.objCuentaPorPagar.MetodoDePago);
            formData.set('FormaDePago',this.objCuentaPorPagar.FormaDePago);

            if (this.objCuentaPorPagar.IdCuentaPagar==0) {
                this.$http.post("/cuentaPorPagar",formData
                ).then((res)=>{
                    this.EjecutaConExito(res);
                }).catch((err)=>{
                    this.EjecutaConError(err);
                });
            }
            else{
                this.$http.post("/cuentaPorPagar/"+this.objCuentaPorPagar.IdCuentaPagar,formData
                ).then((res)=>{
                    this.EjecutaConExito(res);
                }).catch((err)=>{
                    this.EjecutaConError(err);
                });
            }
        },
        EjecutaConExito(res){
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err){
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Recuperar(){
            this.ConfigLoad.ShowLoader=true;
            this.$http.get('/cuentaPorPagar/'+this.objCuentaPorPagar.IdCuentaPagar
            ).then((res)=>{
                this.objCuentaPorPagar.IdProveedor=res.data.data.IdProveedor;
                let formatedDate = res.data.data.FechaPago.replace(/-/g, "\/");
                let formatedDate2 = res.data.data.FechaCompra.replace(/-/g, "\/");
                this.objCuentaPorPagar.FechaPago=new Date(formatedDate);
                this.objCuentaPorPagar.FechaCompra=new Date(formatedDate2);
                this.objCuentaPorPagar.Importe=res.data.data.Importe;
                this.objCuentaPorPagar.DiasCredito=res.data.data.DiasCredito;
                this.objCuentaPorPagar.NumDeCompra=res.data.data.NumDeCompra;
                this.objCuentaPorPagar.IdUsuario=res.data.data.IdUsuario;
                this.objCuentaPorPagar.MetodoDePago=res.data.data.MetodoDePago;
                this.objCuentaPorPagar.FormaDePago=res.data.data.FormaDePago;
                this.objCuentaPorPagar.Concepto=res.data.data.Concepto;
                // this.objCuentaPorPagar.NombreEmpresa=res.data.data.nota_ventas.Cliente;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            });
        },
        Limpiar(){
            this.objCuentaPorPagar={
                IdCuentaPagar:0,
                NumDeCompra:'',
                Concepto:'',
                Importe:0,
                FechaCompra:'',
                FechaPago:'',
                DiasCredito:0,
                Estatus:'',
                IdProveedor:null,
                IdUsuario:0,
                xml:'',
                uuid:'',
                FechaPagado:'',
                MetodoDePago:'',
                FormaDePago:''
            };
        },
        GetListaProveedores(){
            this.$http.get("/proveedores",{
                params:{
                    simple:true
                }
            }).then((res)=>{
                this.ListaProveedoresBusqueda=res.data.data;
                this.ListaProveedores=res.data.data.map((element)=>{
                    return{
                        label:element.RazonSocial,
                        id:element.IdProveedor
                    }
                });
            })
        },
        GetListaMetodoPago(){
            this.$http.get("/metodospago",{
                params:{
                    simple:true
                }
            }
            ).then((res)=>{
                this.ListaMetodoPago=res.data.data;
            });
        },
        GetListaFormaPago(){
            this.$http.get("/formaspago",{
                params:{
                    simple:true
                }
            }
            ).then((res)=>{
                this.ListaFormaPago=res.data.data;
            });
        },
        RellenarCampos(){
            let index=this.ListaProveedoresBusqueda.findIndex((element)=>element.IdProveedor==this.objCuentaPorPagar.IdProveedor);
            this.objCuentaPorPagar.DiasCredito=this.ListaProveedoresBusqueda[index].DiasCredito;
            this.CalcularFechaPago();

        },
        CalcularFechaPago(){
            var dateNvo=moment(new Date()).format('YYYY-MM-DD');
            var dateEl = dateNvo.split("-");
			var date = new Date(dateEl[0],(dateEl[1]-1),dateEl[2])
            if (this.objCuentaPorPagar.DiasCredito!="0" || this.objCuentaPorPagar.DiasCredito!="") {
                var newDate=date.setDate(date.getDate()+Number(this.objCuentaPorPagar.DiasCredito));
            }
            else{
                var newDate=date.setDate(date.getDate()+2);
            };
            this.objCuentaPorPagar.FechaPago=new Date(newDate);
        },
        CalcularDiaCredito(){
            let DateStrFechaPago=moment(this.objCuentaPorPagar.FechaPago).format('YYYY-MM-DD');
            let DateStrFechaPagoEl=DateStrFechaPago.split('-');
            let DateFechaPago=new Date(DateStrFechaPagoEl[0],(DateStrFechaPagoEl[1]-1),DateStrFechaPagoEl[2]);
            // console.log(DateStrFechaPago);

            let DateStrFechaGenerado=moment(new Date()).format('YYYY-MM-DD');
            let DateStrFechaGeneradoEl=DateStrFechaGenerado.split('-');
            let DateFechaGenerado=new Date(DateStrFechaGeneradoEl[0],(DateStrFechaGeneradoEl[1]-1),DateStrFechaGeneradoEl[2]);

            let FechaPagoCalcular=DateFechaPago.setMinutes(DateFechaPago.getMinutes()-DateFechaPago.getTimezoneOffset());
            let FechaGeneradoCalcular=DateFechaGenerado.setMinutes(DateFechaGenerado.getMinutes()-DateFechaGenerado.getTimezoneOffset());

            this.objCuentaPorPagar.DiasCredito=Math.round((FechaPagoCalcular-FechaGeneradoCalcular)/(1000*60*60*24));
        }
    },
    created() {
        this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
            this.GetListaProveedores();
            this.GetListaMetodoPago();
            this.GetListaFormaPago();
                
            if (Id!='') 
            {
                this.objCuentaPorPagar.IdCuentaPagar = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    },
}
</script>

<style>

</style>